import { PlatformAdminCustomerInvoiceComponent } from '@engineering11/payment-web'
import { DynamicComponentConfig } from '@engineering11/platform-admin-web'
import { ActAsCustomerComponent } from './components/act-as-customer/act-as-customer.component'

export const dynamicComponents: Partial<DynamicComponentConfig> = {
  routes: [],
  tabs: [
    {
      label: 'Subscriptions',
      id: 'subscriptions',
      component: PlatformAdminCustomerInvoiceComponent,
    },
    {
      // "View as customer" lives on the platform-admin customer view (reached from Customer Search),
      // not CRM. The view sets `selectedCustomerKey` on the component; it self-hides without
      // admin/impersonate. (Left panel above Deactivate has no SDK injection seam — tab is the seam.)
      label: 'View as customer',
      id: 'view-as-customer',
      component: ActAsCustomerComponent,
    },
  ],
  components: [],
}
